var _path, _path2, _rect, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "job-warning-a",
    d: "M9,1.125A7.875,7.875,0,1,1,1.125,9,7.884,7.884,0,0,1,9,1.125M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Z",
    fill: "#ed7000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "job-warning-a",
    d: "M9.347,10.832l.339-3.761V4.5H8.314V7.071l.339,3.761Z",
    transform: "translate(-0.002)",
    fill: "#ed7000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "job-warning-a",
    width: 1.495,
    height: 1.527,
    transform: "translate(8.25 11.973)",
    fill: "#ed7000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "job-warning-a",
    d: "M9.347,10.832l.339-3.761V4.5H8.314V7.071l.339,3.761Z",
    transform: "translate(-0.001)",
    fill: "#ed7000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "job-warning-a",
    width: 1.495,
    height: 1.527,
    transform: "translate(8.25 11.973)",
    fill: "#ed7000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/job-warning.fe378f066d51db137b153fc17d24aad9.svg";